/* eslint-disable max-len */
import React from 'react';

const Refresh: React.FC = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_11628_307406)">
                <path
                    d="M1.33301 1.33165V5.49782H1.81801M1.81801 5.49782C2.37122 4.12976 3.36274 2.98387 4.6372 2.23976C5.91166 1.49564 7.39701 1.19534 8.86048 1.38592C10.324 1.57651 11.6828 2.2472 12.7242 3.2929C13.7655 4.33859 14.4304 5.70019 14.6147 7.16429M1.81801 5.49782H5.49967M14.6663 14.6634V10.4972H14.1822M14.1822 10.4972C13.6282 11.8645 12.6364 13.0095 11.362 13.7529C10.0877 14.4964 8.60279 14.7963 7.13976 14.6058C5.67673 14.4153 4.31817 13.7451 3.27679 12.7001C2.2354 11.6551 1.56997 10.2943 1.38467 8.83076M14.1822 10.4972H10.4997"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_11628_307406">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Refresh;